
import Vue, { PropType } from 'vue';

export interface GlassToggleOption {
	value: string | boolean;
	label?: string;
	icon?: string;
	tooltip?: string;
	[key: string]: any;
}

export default Vue.extend({
	name: 'BaseGlassToggleButton',
	props: {
		value: {
			type: [String, Boolean] as PropType<string | boolean>,
			required: true,
		},
		options: {
			type: Array as PropType<GlassToggleOption[]>,
			required: true,
			validator: (options: GlassToggleOption[]) => Array.isArray(options) && options.length >= 2,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		iconSize: {
			type: Number,
			default: 20,
		},
		height: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		iconStyle (): Record<string, string> {
			return { fontSize: `${this.iconSize}px` };
		},
		containerStyle (): Record<string, string> {
			return this.height ? { height: `${this.height}px` } : {};
		},
		segmentStyle (): Record<string, string> {
			return this.height ? { minWidth: `${this.height + 14}px` } : {};
		},
	},
	methods: {
		setOption (option: GlassToggleOption, event: Event) {
			if (!this.disabled && option.value !== this.value) {
				this.$emit('input', option.value);
			}
			(event.target as HTMLElement).blur();
		},
	},
});
